<script lang="ts">
	import { _ } from 'svelte-i18n';
	import { page } from '$app/stores';
	import FastBtn from '$lib/component/fast-btn.svelte';
	import Footer from '$lib/component/footer.svelte';
	import Navbar from '$lib/component/navbar.svelte';
	import Partner from '$lib/component/partner.svelte';
	import { initHeroHomeSwiper } from '$lib/js/script.js';
	import { onMount } from 'svelte';

	import type { PageServerData } from './$types';
	export let data: PageServerData;

	const lang = $page.params.locale;

	let partner = data?.partner;
	let dining = data?.dining;
	let award = data?.award;

	onMount(() => {
		initHeroHomeSwiper();

		const script = document.createElement('script');
		script.src = 'https://unpkg.com/@phosphor-icons/web';
		script.async = true;
		document.head.appendChild(script);
	});
</script>

<svelte:head>
	<title>Dining - Holiday Inn Resort Bali Nusa Dua</title>
	<link rel="canonical" href="https://balinusadua.holidayinnresorts.com/en/dining" />
</svelte:head>

<Navbar />

<FastBtn />

<section id="rooms">
	<div id="hero-banner" class="container-fluid p-0">
		<div class="w-100 h-100 p-md-0 p-0 position-relative overflow-hidden">
			<img alt="Holiday Inn Resorts Nusa Dua" src="/img/bg-header-dining.jpg" class="img-header" />
			<div id="hero-text" class="position-absolute top-0 start-0 w-100 h-100">
				<!-- <div class="row g-0 w-100 h-100 justify-content-center align-items-center">
					<div class="col-md-6 text-center text-white p-3">
						<h1 class="ff-lola-bir display-3 mb-3">Dining</h1>
					</div>
				</div> -->
			</div>
		</div>
	</div>

	<div class="container-fluid py-md-5 py-5 px-0 rooms-welcome position-relative">
		<div class="row g-0 justify-content-center mt-md-5 mt-4 mb-md-5 mb-5">
			<div class="col-md-10 px-md-5 px-3 text-center">
				<p class="mb-md-3 main-color display-5 pe-md-3 ff-lola-bir lh-2">{$_('dining_title_1')}</p>
				<p class="line mb-md-4 mb-3 mx-auto"></p>
				<p class="ff-helvetica mb-md-4 mb-3">
					{$_('dining_desc_1')}
				</p>
				<p class="main-color ff-lola-mr fs-5">{$_('dining_time_1')}</p>
			</div>
		</div>
		<div class="row g-0 align-items-center">
			{#each dining as dining, index}
				{#if index % 2 === 0}
					<div class="col-md-12 row g-0 py-md-5 py-3">
						<div
							class="col-md-9 col-11 fs-5 main-color ff-lola-mr text-uppercase mb-md-4 mb-3 img-dining"
						>
							<div class="swiper slider-img-room position-relative">
								<div class="swiper-wrapper">
									{#each dining.featured_images as img}
										<div class="swiper-slide">
											<div class="ratio ratio-21x9 rounded-end-4">
												<img src={img.path} class="w-100 h-100 object-fit-cover rounded-end-4" />
											</div>
										</div>
									{/each}
								</div>

								<div
									class="nav-slider-img-room position-absolute top-0 start-0 w-100 h-100 d-flex align-items-end justify-content-end z-3 p-md-4 p-3"
								>
									<div class="d-flex">
										<span class="btn-prev d-flex align-items-center justify-content-center me-2"
											><i class="ph-light ph-caret-left"></i></span
										>
										<span class="btn-next d-flex align-items-center justify-content-center"
											><i class="ph-light ph-caret-right"></i></span
										>
									</div>
								</div>

								<div
									class="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-end justify-content-md-center justify-content-start z-2 p-md-4 p-3 text-white"
								>
									<div class="swiper-pagination pagination-slider-img-room"></div>
								</div>
							</div>
						</div>
						<div class="col-md-8 col-10 offset-1 offset-md-1">
							<p class="mb-3 main-color display-5 ff-lola-bir lh-2">{dining?.name}</p>
							<p class="line mb-md-4 mb-3"></p>
							<p class="ff-helvetica">{dining.excerpt}</p>
							<div class="mb-4">
								<div>
									{#if dining.session.breakfast != 0}
										<div class="row g-0">
											<div class="col-md-2 ff-lola-mr mb-0 fs-5">
												<i class="ph-light ph-fork-knife me-2 align-middle"></i><span
													class="fw-medium">{$_('breakfast')}</span
												>
											</div>
											<div class="col-md-8 ff-helvetica mb-md-3 mb-2">
												<small>{dining.session.breakfast_detail}</small>
											</div>
										</div>
									{/if}
									{#if dining.session.lunch != 0}
										<div class="row g-0">
											<div class="col-md-2 ff-lola-mr mb-0 fs-5">
												<i class="ph-light ph-fork-knife me-2 align-middle"></i><span
													class="fw-medium">{$_('lunch')}</span
												>
											</div>
											<div class="col-md-8 ff-helvetica mb-md-3 mb-2">
												<small>{dining.session.lunch_detail}</small>
											</div>
										</div>
									{/if}
									{#if dining.session.dinner != 0}
										<div class="row g-0">
											<div class="col-md-2 ff-lola-mr mb-0 fs-5">
												<i class="ph-light ph-fork-knife me-2 align-middle"></i><span
													class="fw-medium">{$_('dinner')}</span
												>
											</div>
											<div class="col-md-8 ff-helvetica mb-md-3 mb-2">
												<small>{dining.session.dinner_detail}</small>
											</div>
										</div>
									{/if}
								</div>
							</div>
							<p class="ff-lola-mr">
								<a
									target="_blank"
									href="mailto:guestservices.hirnusadua@ihg.com"
									class="btn main-btn px-4 py-2 me-2 mb-2">{$_('btn_reservation')}</a
								>
								{#if dining.menu != null}
									{#each dining.menu as menu}
										<a href="http://50.6.171.246/~hirnusadua/cms/storage/app/media{menu.file}" target="_blank" class="btn main-btn-outline me-2 mb-2 px-4 py-2"
											>
											<i class="align-middle ph ph-download-simple me-1"></i> 
											{#if lang == "id"}
												{menu.id_name}
											{:else if lang == "cn"}
												{menu.cn_name}
											{:else if lang == "kr"}
												{menu.kr_name}
											{:else if lang == "ru"}
												{menu.ru_name}
											{:else}
												{menu.name}
											{/if}
										</a>
									{/each}
								{/if}
							</p>
						</div>
					</div>
				{:else}
					<div class="col-md-12 row g-0 py-md-5 py-3 right-content-rooms">
						<div
							class="col-md-9 col-11 offset-1 offset-md-3 fs-5 main-color ff-lola-mr text-uppercase mb-md-4 mb-3 img-dining"
						>
							<div class="swiper slider-img-room position-relative">
								<div class="swiper-wrapper">
									{#each dining.featured_images as img}
										<div class="swiper-slide">
											<div class="ratio ratio-21x9 rounded-start-4">
												<img src={img.path} class="w-100 h-100 object-fit-cover rounded-start-4" />
											</div>
										</div>
									{/each}
								</div>

								<div
									class="nav-slider-img-room position-absolute top-0 start-0 w-100 h-100 d-flex align-items-end justify-content-start z-3 p-md-4 p-3"
								>
									<div class="d-flex">
										<span class="btn-prev d-flex align-items-center justify-content-center me-2"
											><i class="ph-light ph-caret-left"></i></span
										>
										<span class="btn-next d-flex align-items-center justify-content-center"
											><i class="ph-light ph-caret-right"></i></span
										>
									</div>
								</div>

								<div
									class="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-end justify-content-md-center justify-content-end z-2 p-md-4 p-3 text-white"
								>
									<div class="swiper-pagination pagination-slider-img-room"></div>
								</div>
							</div>
						</div>
						<div class="col-md-8 col-10 offset-1 offset-md-3">
							<p class="mb-3 main-color display-5 ff-lola-bir lh-2">{dining.name}</p>
							<p class="line mb-md-4 mb-3"></p>
							<p class="ff-helvetica">{dining.excerpt}</p>
							<div class="mb-4">
								<div>
									{#if dining.session.breakfast != 0}
										<div class="row g-0">
											<div class="col-md-2 ff-lola-mr mb-0 fs-5">
												<i class="ph-light ph-fork-knife me-2 align-middle"></i><span
													class="fw-medium">{$_('breakfast')}</span
												>
											</div>
											<div class="col-md-8 ff-helvetica mb-md-3 mb-2">
												<small>{dining.session.breakfast_detail}</small>
											</div>
										</div>
									{/if}
									{#if dining.session.lunch != 0}
										<div class="row g-0">
											<div class="col-md-2 ff-lola-mr mb-0 fs-5">
												<i class="ph-light ph-fork-knife me-2 align-middle"></i><span
													class="fw-medium">{$_('lunch')}</span
												>
											</div>
											<div class="col-md-8 ff-helvetica mb-md-3 mb-2">
												<small>{dining.session.lunch_detail}</small>
											</div>
										</div>
									{/if}
									{#if dining.session.dinner != 0}
										<div class="row g-0">
											<div class="col-md-2 ff-lola-mr mb-0 fs-5">
												<i class="ph-light ph-fork-knife me-2 align-middle"></i><span
													class="fw-medium">{$_('dinner')}</span
												>
											</div>
											<div class="col-md-8 ff-helvetica mb-md-3 mb-2">
												<small>{dining.session.dinner_detail}</small>
											</div>
										</div>
									{/if}
								</div>
							</div>
							<p class="ff-lola-mr">
								<a
									target="_blank"
									href="{dining.book_url}"
									class="btn main-btn px-4 py-2 me-2 mb-2">{$_('btn_reservation')}</a
								>
								{#if dining.menu != null}
									{#each dining.menu as menu}
										<a href="http://50.6.171.246/~hirnusadua/cms/storage/app/media{menu.file}" target="_blank" class="btn main-btn-outline me-2 mb-2 px-4 py-2"
											><i class="align-middle ph ph-download-simple me-1"></i>
											{#if lang == "id"}
											{menu.id_name}
											{:else if lang== "cn"}
											{menu.cn_name}
											{:else if lang== "kr"}
											{menu.kr_name}
											{:else if lang== "ru"}
											{menu.ru_name}
											{:else}
											{menu.name}
											{/if}
										</a>
									{/each}
								{/if}
							</p>
						</div>
					</div>
				{/if}
			{/each}
		</div>
	</div>
</section>

<Partner {partner} />

<Footer {award} />

<style>
	#hero-text {
		background-color: rgba(0, 0, 0, 0.3);
	}
	.rooms-welcome::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100vh;
		z-index: -1;
		margin-bottom: -2px;
		background-image: linear-gradient(
				to top,
				rgba(255, 255, 255, 1),
				rgba(255, 255, 255, 0.85),
				rgba(255, 255, 255, 0.8)
			),
			url('/img/bg-home-1.jpg');
		background-position: center;
		background-size: cover;
	}
	.line {
		border-bottom: 2px solid #451C70;
		width: 25%;
	}

	.slider-img-room .nav-slider-img-room .btn-prev,
	.slider-img-room .nav-slider-img-room .btn-next {
		width: 50px;
		height: 50px;
		border-radius: 10px;
		border: 2px solid white;
		color: white;
		font-size: 26px;
		cursor: pointer;
		transition: 0.3s all;
	}
	.slider-img-room .nav-slider-img-room .btn-prev:hover,
	.slider-img-room .nav-slider-img-room .btn-next:hover {
		background-color: rgba(255, 255, 255, 0.3);
		transition: 0.3s all;
	}
	.pagination-slider-img-room {
		bottom: unset !important;
		top: unset !important;
		left: unset !important;
		width: unset !important;
		font-size: 26px !important;
	}

	.rooms-welcome .right-content-rooms {
		position: relative;
	}
	.rooms-welcome .right-content-rooms:before {
		content: '';
		position: absolute;
		top: 0;
		right: 0;
		width: 20%;
		height: 60%;
		background-color: #451C70;
	}
	@media (max-width: 600px) {
		.rooms-welcome .right-content-rooms:before {
			content: unset;
		}
		.img-dining .ratio-21x9 {
			aspect-ratio: 9/7 !important;
		}
	}
</style>
